const TAGS = [
  ["first_name", (u) => (u?.name ? u.name.split(/\s+/)[0] : "")],
  ["full_name", (u) => u?.name || ""],
  ["company_name", (u) => u?.company || ""],
  ["email", (u) => u?.email || ""],
];

/**
 * Apply {{tag}} placeholders (Intercom-style) using the conversation user.
 */
export function applyCannedMergeTags(template, user) {
  if (!template) return "";
  let out = template;
  for (const [key, fn] of TAGS) {
    const re = new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, "gi");
    out = out.replace(re, fn(user) || "");
  }
  return out;
}

/** Shortcut slug: lowercase letters, numbers, hyphen (leading / is not stored). */
export function normalizeShortcut(raw) {
  return String(raw || "")
    .trim()
    .replace(/^\//, "")
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, "")
    .slice(0, 40);
}

/**
 * Match an in-progress /shortcut at the end of the text before cursor (composer).
 */
export function matchSlashQuery(text, cursorPos) {
  const before = text.slice(0, cursorPos);
  const m = before.match(/(?:^|\n)\/([a-z0-9-]*)$/i);
  if (!m) return null;
  return { start: before.length - m[0].length, query: m[1].toLowerCase() };
}
